import { render, staticRenderFns } from "./CreateActivityForm.vue?vue&type=template&id=0524fb9e&lang=pug&"
import script from "./CreateActivityForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateActivityForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports